import { Handle, Position } from "@xyflow/react";
import { CATEGORIES, blockDef, summarize } from "./blocks";

export default function BuilderNode({ data, selected }) {
  const cat = CATEGORIES[data.category] || {};
  const def = blockDef(data.category, data.kind);
  const Icon = def?.icon;
  const summary = summarize(data);
  return (
    <div
      data-testid={`node-${data.kind}`}
      className={`w-52 rounded-lg border-2 bg-white px-3 py-2.5 transition-shadow ${
        selected ? "border-zinc-900 shadow-lg" : "border-zinc-200"
      }`}
      style={{ borderLeftColor: cat.color, borderLeftWidth: 4 }}
    >
      {data.category !== "trigger" && (
        <Handle type="target" position={Position.Top} className="!w-3 !h-3 !bg-zinc-400" />
      )}
      <div className="flex items-center gap-2">
        {Icon && <Icon size={16} weight="bold" style={{ color: cat.color }} />}
        <span className="text-[10px] uppercase tracking-wider font-bold" style={{ color: cat.color }}>
          {cat.label}
        </span>
      </div>
      <div className="text-sm font-semibold text-zinc-900 mt-0.5 leading-tight">{data.label}</div>
      {summary && <div className="text-[11px] text-zinc-500 mt-0.5 truncate">{summary}</div>}
      {data.category === "condition" ? (
        <>
          <Handle type="source" id="yes" position={Position.Bottom} style={{ left: "30%" }}
            className="!w-3 !h-3 !bg-emerald-500" />
          <Handle type="source" id="no" position={Position.Bottom} style={{ left: "70%" }}
            className="!w-3 !h-3 !bg-rose-500" />
          <div className="flex justify-between text-[10px] font-bold mt-1 px-2">
            <span className="text-emerald-600">SÌ</span>
            <span className="text-rose-600">NO</span>
          </div>
        </>
      ) : (
        data.kind !== "fine" && (
          <Handle type="source" position={Position.Bottom} className="!w-3 !h-3 !bg-zinc-400" />
        )
      )}
    </div>
  );
}
